import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { Button } from "@chakra-ui/react"
import { Button as AntButton } from "antd"
import { useTranslation } from "react-i18next"
import { useForm, useFieldArray } from "react-hook-form"
import { useHistory } from "react-router-dom"

import _ from "lodash"
import Layout from "../../components/layout/GeneralLayout"
import { WhitePanel, MaterialForm, Alert, SpinnerLoading } from "../../components"

import * as actions from "../../redux/actions"

export default function CreateManyMaterial() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const { control, handleSubmit } = useForm({ defaultValues: { arr: [{}] } })
  const [isLoading, setIsLoading] = useState(true)
  const [isError, setIsError] = useState(false)
  const [errMessage, setErrMessage] = useState("")
  const { fields, append, remove } = useFieldArray({
    name: "arr",
    control,
  })

  const handleCreateMaterial = (data) => {
    console.log("Data", data)
    dispatch(actions.createOneMaterial({ ...data, many: true }))
      .then(() => {
        history.goBack()
      })
      .catch((err) => {
        setIsError(true)
        setErrMessage(err?.message)
      })
  }

  if (!isLoading) {
    return <SpinnerLoading />
  }

  return (
    <Layout categoryTitle={t("inventory.title")} title="สร้างวัตถุดิบ">
      <Alert errMessage={errMessage} isError={isError} handleOnClose={() => setIsError(false)} />
      <div className="flex justify-between flex-wrap px-4">
        <Button colorScheme="purple" variant="outline" onClick={() => history.goBack()}>
          {t("general.back")}
        </Button>

        <div className="w-full md:w-1/4  self-center mt-2"></div>
      </div>
      <div className="p-4">
        <form onSubmit={handleSubmit(handleCreateMaterial)}>
          <WhitePanel>
            {_.map(fields, (field, index) => (
              <div key={field?.id}>
                <MaterialForm control={control} formSize="medium" index={index} onMany />
                <div className="flex justify-end">
                  <AntButton danger onClick={() => remove(index)}>
                    ลบ
                  </AntButton>
                </div>
                <hr className="my-2" />
              </div>
            ))}

            <AntButton
              type="dashed"
              onClick={() => append({})}
              block
              icon={<i className="fas fa-plus" />}
            >
              เพิ่ม
            </AntButton>
          </WhitePanel>
          <Button colorScheme="purple" variant="solid" type="submit" isFullWidth>
            {t("general.save")}
          </Button>
        </form>
      </div>
    </Layout>
  )
}
